const PLACEHOLDER = /\$\{([^}]*)\}/g;

const isEmpty = (value: unknown) => value === undefined || value === null || value === "";

/** Splits on `??` outside quotes, so a literal may contain `??` itself. */
const splitOperands = (expression: string): string[] => {
  const operands: string[] = [];
  let quote: string | null = null;
  let current = "";
  for (let i = 0; i < expression.length; i++) {
    const char = expression[i];
    if (quote) {
      if (char === quote) quote = null;
    } else if (char === '"' || char === "'") {
      quote = char;
    } else if (char === "?" && expression[i + 1] === "?") {
      operands.push(current);
      current = "";
      i++;
      continue;
    }
    current += char;
  }
  operands.push(current);
  return operands.map((operand) => operand.trim());
};

const literalOf = (operand: string) => /^(["'])([\s\S]*)\1$/.exec(operand)?.[2];

/** Every variable path a template reads, fallbacks included. */
export const templatePaths = (template: string): string[] => [
  ...new Set(
    [...template.matchAll(PLACEHOLDER)]
      .flatMap((match) => splitOperands(match[1]))
      .filter((operand) => operand && literalOf(operand) === undefined),
  ),
];

/**
 * Renders a `${path}` string. `${a ?? b ?? "text"}` takes the first operand that
 * is not null, undefined or "". Unresolved placeholders render empty.
 */
export const renderTemplate = (template: string, resolve: (path: string) => unknown): string => {
  if (!template.includes("${")) return template;
  return template.replace(PLACEHOLDER, (_, expression: string) => {
    for (const operand of splitOperands(expression)) {
      const value = literalOf(operand) ?? resolve(operand);
      if (!isEmpty(value)) return typeof value === "object" ? JSON.stringify(value) : String(value);
    }
    return "";
  });
};
